import React from 'react';

import { Link } from 'react-resource-router';

import { Text } from '@atlaskit/primitives';

import { urls } from 'src/components/settings/gpg-keys/urls';
import { useIntl } from 'src/hooks/intl';

import { messages } from '../../../gpg-keys.i18n';

export const GpgKeysUnverifiedCardContent = (): JSX.Element | null => {
  const { formatMessage } = useIntl();

  return (
    <>
      <Text size="small">
        {formatMessage(messages.notVerifiedDescription)}{' '}
        <Link href={urls.gpgKeyCreation}>
          {formatMessage(messages.configureGpgKeysText)}
        </Link>
      </Text>
    </>
  );
};
